<app-modal-dialog [show]="showModal" size="auto" position="center" #modal>
    <div class="modal-header" modal-header>
        <h1>Crea un pedido Pollos</h1>
        <h1 style="left: 0" class="i-hover">
            <i class="fa fa-xmark" (click)="closeModal(modal)"></i>
        </h1>
    </div>

    <div class="modal-body" modal-body>
        <div class="row">
            <div
                id="client-input-container"
                class="input-group input-group-sm mb-2"
            >
                <label for="client-input" class="input-group-text"
                    >Cliente <span >*</span></label
                >
                <app-input-autocomplete
                    [allBorderRadius]="false"
                    [inputs]="inputs.client"
                    [placeholder]="'Ingresa o crea un cliente'"
                    [filterElements]="filterClients"
                    [typeElements]="'client'"
                    (inputMethod)="handleInput($event.event, 'client')"
                    (getTitle)="
                        $event.filterElement.title =
                            $event.filterElement.nit +
                            ' - ' +
                            $event.filterElement.name
                    "
                    (changeStatus)="
                        changeStatusInputClient(
                            $event.filterElement,
                            $event.filterElement.nit +
                                ' - ' +
                                $event.filterElement.name,
                            1
                        )
                    "
                ></app-input-autocomplete>
            </div>

            <div class="col-sm-6 form-group">
                <label for="date" class="form-label"
                    >Fecha<span class="required">*</span></label
                >
                <input
                    type="date"
                    [ngModel]="date | date : 'yyyy-MM-dd'"
                    (ngModelChange)="date = $event"
                    name="date"
                    id="date"
                    class="form-control"
                />
            </div>
            <div class="col-sm-6 form-group">
                <label for="warehouse-order" class="form-label"
                    >Bodega<span class="required">*</span></label
                >
                <div class="input-group">
                    <app-input-autocomplete
                        [allBorderRadius]="true"
                        [inputs]="inputs.warehouse"
                        [placeholder]="'Ingresa una bodega'"
                        [filterElements]="filterWarehouses"
                        [typeElements]="'warehouse-order'"
                        (inputMethod)="writeWarehouse($event.event)"
                        (changeStatus)="checkWarehouse($event.filterElement)"
                        (getTitle)="
                            $event.filterElement.title =
                                $event.filterElement.name
                        "
                    ></app-input-autocomplete>
                </div>
            </div>

            <div class="col-sm-6 form-group" *ngIf="inputs.warehouse.value!=null">
                <label for="product-order" class="form-label">Producto</label>
                <div class="input-group">
                    <app-input-autocomplete
                        [allBorderRadius]="true"
                        [inputs]="inputs.product"
                        [placeholder]="'Ingresa un producto'"
                        [filterElements]="filterProducts"
                        [typeElements]="'product-order'"
                        (inputMethod)="writeProduct($event.event)"
                        (changeStatus)="checkProduct($event.filterElement)"
                        (getTitle)="
                            $event.filterElement.title =
                                $event.filterElement.code +
                                ' - ' +
                                $event.filterElement.name
                        "
                    ></app-input-autocomplete>
                </div>
            </div>
            <div class="col-sm-6 form-group" *ngIf="inputs.warehouse.value!=null">
                <label for="ammount" class="form-label">Cantidad</label>
                <div class="input-group">
                    <input
                        type="number"
                        name="ammount"
                        id="ammount"
                        [(ngModel)]="quantity"
                        class="form-control"
                    />
                    <button
                        class="btn btn-primary"
                        (click)="addProduct()"
                        title="Agregar producto"
                        [disabled]="!inputs.product.verified || quantity <= 0 || inputs.warehouse.value==null"
                    >
                        <span class="superposition-container">
                            <i class="fa fa-boxes"></i>
                            <i
                                style="color: yellow"
                                class="fa fa-plus superposition-element"
                            ></i>
                        </span>
                    </button>
                </div>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col text-end text-danger" *ngIf="currentClient==null">
                <span>Crédito Disponible: Cliente sin seleccionar.</span>
            </div>
            <div class="col text-end text-danger" *ngIf="currentClient!=null">
                <span>Crédito Disponible: Q </span>
                <span>{{ totalCreditAvailable }}</span>
            </div>
        </div>
        <div class="row" *ngIf="productList.length > 0">
            <div class="col">
                <div class="table-responsive" style="max-height: 200px">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th>Producto</th>
                                <th class="td-center bg-info-subtle">En Bodega</th>
                                <th class="td-center bg-warning-subtle">En Tránsito</th>
                                <th class="text-right">Cantidad</th>
								<th class="text-right">Precio</th>
								<th class="text-right">Subtotal</th>
                                <th class="td-center">
                                    <div class="d-flex form-group flex-column">
                                        <label class="form-label">
                                            Apartar
                                        </label>
                                            <input
                                                type="checkbox"
												[(ngModel)]="stateCheckbox"
												(change)="onCheckboxChange($event)"
                                            />
                                    </div>
                                </th>
                                <th class="td-center">Opciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                *ngFor="
                                    let product of productList;
                                    let i = index
                                "
                            >
                                <td>
                                    {{ product.productData.name }}
                                </td>
                                <td class="td-center bg-info-subtle">
                                    {{ product.existences }}
                                </td>
                                <td class="td-center bg-warning-subtle">
                                    {{ product.waiting }}
                                </td>
                                <td class="td-center" style="max-width: 85px;min-width: 85px;">
									<div class="input-group input-group-sm">
										<input 
										type="number" 
										[(ngModel)]="product.quantity" 
										class="form-control"
										style="text-align: center;"
										min="0" step="0.01">
									</div>
                                </td>
								<td class="td-center" style="max-width: 85px;min-width: 85px;">
									<div class="input-group input-group-sm">
										<input 
										type="number" 
										[(ngModel)]="product.price" 
										class="form-control"
										style="text-align: center;"
										min="0" step="0.01">
									</div>
                                </td>
								<td class="text-right">
                                    Q {{ (product.quantity*product.price).toFixed(2) }}
                                </td>
                                <td class="td-center">
                                    <input type="checkbox" [(ngModel)]="product.reserve"/>
                                </td>
                                <td class="td-center">
                                    <div
                                        style="
                                            display: flex;
                                            justify-content: space-evenly;
                                        "
                                    >
                                        <span
                                            class="clickeable text-danger"
                                            (click)="deleteProductFromList(i)"
                                        >
                                            <i class="fa fa-trash"></i>
                                        </span>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
						<tfoot>
							<tr>
								<td colspan="5">Total</td>
								<td class="text-right">Q {{totalOrder}}</td>
								<td colspan="2"></td>
							</tr>
						</tfoot>
                    </table>
                </div>
            </div>
        </div>
        <p
            class="text-muted"
            style="margin-top: 1em; font-size: 0.8em; text-align: right"
        >
            <i class="fa fa-circle-info"></i>Completa los campos marcados con un
            <span class="required">*</span> y agrega productos para crear el
            pedido
        </p>
    </div>

    <div class="modal-footer" modal-footer>
		<button class="btn btn-success" (click)="createOrder()"
			[disabled]="loading || !inputs.warehouse.verified || !date || productList.length == 0 || currentClient==null">
			<ng-container *ngIf="!loading">
				<i class="fa fa-floppy-disk"></i>
			</ng-container>
			<ng-container *ngIf="loading">
				<span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
				<span role="status"></span>
			</ng-container>GUARDAR
		</button>
	</div>
</app-modal-dialog>
